import * as React from "react";
import Svg, { Path } from "react-native-svg";

const QA = (props) => (
  <Svg
    width={65}
    height={65}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M32.5 0C28.25 0 25 3.25 25 7.5v15c0 4.25 3.25 7.5 7.5 7.5h15l10 10V30c4.25 0 7.5-3.25 7.5-7.5v-15C65 3.25 61.75 0 57.5 0h-25Zm10.47 7.5h4.295l4.22 15h-3.75l-1.017-3.75h-3.75l-.936 3.75H38.75l4.22-15ZM45 10c-.25 1-.53 2.22-.782 2.97l-.7 3.28h2.967l-.705-3.283C45.282 12.22 45 11 45 10ZM7.5 25C3.25 25 0 28.25 0 32.5v15C0 51.75 3.25 55 7.5 55v10l10-10h15c4.25 0 7.5-3.25 7.5-7.5v-15h-7.5c-4.75 0-8.515-3.25-9.765-7.5H7.5Zm11.485 7.265c4.25 0 6.25 3.5 6.25 7.5 0 3.5-1.203 5.72-3.203 6.72 1 .5 2.186.765 3.436 1.015l-.936 2.5c-1.75-.5-3.564-1.28-5.314-2.032-.25-.25-.688-.233-.938-.233-3-.25-5.78-2.735-5.78-7.735 0-4.25 2.485-7.735 6.485-7.735Zm0 2.735c-2 0-2.97 2.25-2.97 5 0 3 .97 5 2.97 5s3.045-2.25 3.045-5-1.045-5-3.045-5Z"
      fill="#fff"
    />
  </Svg>
);

export default QA;
